import { FormData } from ".";

export const emptyValues: FormData = {
  country: "US",
  type: "Business",
  representativeConfirmation: false
};
